export function loginErrorMessage(error: any): string {
  const status = error?.response?.status;
  if (status === 401) return "E-mail ou senha incorretos. Confira os dados e tente novamente.";
  if (status === 403 && (error.isUnverified || String(error.response?.data?.message || "").startsWith("Conta não verificada"))) {
    return "Sua conta ainda não foi ativada. Abra o e-mail de confirmação e clique no link de ativação. Confira também a caixa de spam.";
  }
  if (status === 429 || error?.isRateLimited) {
    const raw = error?.response?.headers?.["retry-after"];
    const seconds = typeof raw === "string" || typeof raw === "number" ? Number(raw) : NaN;
    if (Number.isFinite(seconds) && seconds > 0 && seconds <= 86400) {
      const minutes = Math.ceil(seconds / 60);
      return `Muitas tentativas de login. Aguarde ${minutes} ${minutes === 1 ? "minuto" : "minutos"} antes de tentar novamente.`;
    }
    return "Muitas tentativas de login. Aguarde alguns minutos antes de tentar novamente.";
  }
  if (["ECONNABORTED", "ETIMEDOUT"].includes(error?.code)) return "O servidor demorou para responder. Tente novamente em instantes.";
  if (error?.code === "INVALID_LOGIN_RESPONSE") return "O servidor não concluiu o login corretamente. Tente novamente em instantes.";
  if (!error?.response && (error?.isAxiosError || error?.code === "ERR_NETWORK")) {
    return "Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.";
  }
  if (status >= 500 || status === 404) return "O serviço de login está temporariamente indisponível. Tente novamente em instantes.";
  if (status === 403) return "Não foi possível autorizar o acesso. Atualize a página e tente novamente.";
  if (status === 400 || status === 422) return "Não foi possível validar os dados de acesso. Confira o e-mail e preencha a senha.";
  return "Não foi possível concluir o login. Tente novamente. Se o problema continuar, entre em contato com insecta@ufrb.edu.br.";
}
